import React from "react";

export default {
    Appeal: {
        definition:
            "How successful the webpage is at communicating product benefits and key value to user.",
        recommendations: [
            {
                title: "Unique Value",
                text: (
                    <p>
                        If you are in a competitive space, visitors generally
                        want to understand what is your unique value.
                    </p>
                )
            },
            {
                title: "Valuable Offers",
                text: (
                    <p>
                        Offers are also ways that companies can appeal more to
                        their target audience. Knowing what visitors value most
                        and providing unique offers to provide this can be the
                        hook that captures more leads. Offer examples include
                        financial perks (dollars, discounts), free trials and
                        guarantees.
                    </p>
                )
            },
            {
                title: "Strong Brand Design",
                text: (
                    <p>
                        Design elements can also be appealing or unappealing and
                        can be supported (or detract from) your brand. Apple and
                        Nike are both incredibly powerful brands: their website
                        and landing page designs reflect their brand image: for
                        Apple, innovative, simple, and elegant: for Nike,
                        focusing on exclusivity (not everyone will "do it"),
                        high performance athletics and stories. How does your
                        design reflect your brand values and audience?
                    </p>
                )
            }
        ]
    },
    Clarity: {
        definition:
            "Your visitor’s ability to quickly understand the purpose of the page, understand  the core benefits and the key features of using  your service.",
        recommendations: [
            {
                title: "Simplified Copy",
                text: (
                    <p>
                        Often content is developed in words and phrases that
                        companies use, not in the lingo of the customers.
                        Content should be clear, simple and feel familiar to
                        visitors and should be edited to be as short as possible
                        while still letting visitors know the point.
                    </p>
                )
            },
            {
                title: "Fine Print",
                text: (
                    <p>
                        We know that your lawyers often want to protect you from
                        every promise or offer and that this is important,
                        however, companies should consider how all this fine
                        print appears to a visitor. Consider ways to reduce the
                        fine print and where it is necessary, make the language
                        transparent and friendly.
                    </p>
                )
            },
            {
                title: "Bullets",
                text: (
                    <p>
                        Most visitors scan versus read your web or landing
                        pages. While it is tempting to say more, your visitors
                        are looking for shortcuts to the information that they
                        want and need to see before taking action. Use short,
                        bulleted text with keywords that resonate with your
                        audience. Save the long form text for blogs and other
                        content.
                    </p>
                )
            },
            {
                title: "High Impact Headlines",
                text: [
                    <p key="highImpaceHeadlines-1">
                        Let your visitors easily find the information that they
                        are looking for. Headlines should reflect both what you
                        know your visitors need and are concerned about
                        (alleviate their fear) and appeal to their greatest hope
                        (aspirational).
                    </p>,
                    <p key="highImpaceHeadlines-2">
                        Sub-headlines can add color to the headline, block
                        headlines should be clear, and help by providing an
                        answer to a question that the visitor has (e.g.
                        Affording your education for content on scholarships,
                        loan programs and tuition costs
                    </p>
                ]
            }
        ]
    },
    Credibility: {
        definition:
            "The level of trustworthiness and believability that your service conveys through your landing page.",
        recommendations: [
            {
                title: "Accreditations",
                text: (
                    <p>
                        Check to see that any necessary accreditations (for
                        example, for professional programs like nursing degrees
                        or HLC for online universities) are visible, ideally
                        above the first fold.
                    </p>
                )
            },
            {
                title: "Testimonials",
                text: (
                    <p>
                        Provide relevant testimonials which both match the
                        content of the page and your core message.
                    </p>
                )
            },
            {
                title: "Brand & Reputation",
                text: (
                    <p>
                        Often credibility is also a reflection of your brand and
                        reputation (or that of your competitors). Ensure that
                        your message addresses the key concerns that visitors
                        likely have about you or your industry.
                    </p>
                )
            },
            {
                title: "Design",
                text: (
                    <p>
                        Credibility can also be a reflection of the design of
                        your page. If your design does not match what your
                        target audience deems is professional (this varies by
                        audience and industry), it can be an immediate "cue" to
                        visitors that you are not worthy of their time.
                    </p>
                )
            }
        ]
    },
    Experience: {
        definition:
            "The ease in which visitors navigate and their overall experience as they attempt to find the information they need.",
        recommendations: [
            {
                title: "Navigation",
                text: (
                    <p>
                        Visitors need to see that they can easily navigate to
                        the information that they feel necessary to see before
                        they "raise their hand" and provide an email address or
                        phone number. Too many options can lead a visitor to get
                        lost on a site; too few, will cause them to abandon it
                        without providing their personal information.
                    </p>
                )
            },

            {
                title: "Page Length",
                text: (
                    <p>
                        Length of page is subjective. The key is to ensure that
                        the information on the page is easy to navigate, has
                        clearly defined sections, and includes only the critical
                        information necessary to get visitors to convert. There
                        have been many cases where WEVO testing has lengthened
                        the page and improved conversion. In all cases, WEVO
                        made the content visually organized, included headings
                        and bullets for key information and included links to
                        more detail.
                    </p>
                )
            },

            {
                title: "Content Order",
                text: (
                    <p>
                        For any website, there is some content that users have
                        to see before they will give the site their attention.
                        Other important content can be almost anywhere on the
                        page, since once engaged, users will give the page their
                        attention. In higher ed, WEVO has found that
                        demonstrating you have the degrees and programs that
                        users want is a must have early on the page. Once found,
                        other things like testimonials, success rates,
                        affordability and more about your school can be
                        elsewhere on the page.
                    </p>
                )
            },

            {
                title: "Button Design",
                text: (
                    <p>
                        Different button content and colors can create
                        dramatically different conversion rates. While many
                        colors can be effective, the most important thing is to
                        ensure that the button has high contrast to the content
                        around it. It helps to add content around the CTA button
                        which describes what will happen when the visitor clicks
                        the button (reducing fear and offering value). You can
                        also test different button copy that is more and less
                        direct and/or descriptive.
                    </p>
                )
            },
            {
                title: "Visual Cues",
                text: [
                    <p key="visualCues-1">
                        ICONS - Use of icons can help users visually understand
                        the content that appears with that icon, without text.
                        Consistency on icons throughout the site can provide
                        users very quick knowledge of where to go.
                    </p>,
                    <p key="visualCues-2">
                        BACKGROUND BLOCKS - Separate the different content
                        sections of your site with different background colors
                        (e.g. rotate white and gray) to make it easy for visitor
                        to recognize a new content block.
                    </p>,
                    <p key="visualCues-3">
                        MIX OF IMAGES & TEXT - Break up the content into blocks
                        with a mix of images and text so that visitors can more
                        easily separate out text blocks and headlines without
                        having them "run together" on the page.
                    </p>,
                    <p key="visualCues-4">
                        USE OF COLOR - Color can be for many visitors one of the
                        best ways to help them visually understand your page and
                        it can also be one that makes a site look cluttered and
                        confusing. For more complex service offerings you may
                        consider color coding by category, or for less complex
                        ones, use color to delineate different content and
                        sections of your site.
                    </p>
                ]
            }
        ]
    },
    Relevance: {
        definition:
            "How well the product and page align with each visitor’s expectation and need for your service.",
        recommendations: [
            {
                title: "Targeting Advertising",
                text: (
                    <p>
                        Are you targeting the right audience with your ads?
                        Ensure that qualified visitors are coming to your web or
                        landing page and develop messaging and content that
                        meets their needs. How? Use the visitor quotes from WEVO
                        test to understand if you are meeting the needs of the
                        target audience.
                    </p>
                )
            },
            {
                title: "Positive Imagery",
                text: (
                    <p>
                        Positive images perform significantly better than
                        serious ones in most instances. Test imagery that is
                        light and happy.
                    </p>
                )
            },
            {
                title: "Realistic Imagery",
                text: (
                    <p>
                        Visitors read much more into imagery than most companies
                        who use them do. Ensure that the images reflect both the
                        real aspirations and the real concerns that they have
                        about using your service.
                    </p>
                )
            },
            {
                title: "Critical Information",
                text: (
                    <p>
                        Find out what is most important for your visitors and
                        ensure that information is provided early in their
                        experience.
                    </p>
                )
            }
        ]
    }
};

export const DRIVER_ORDER = [
    "Appeal",
    "Clarity",
    "Credibility",
    "Experience",
    "Relevance"
];

export const BENCHMARK_POINTS = 5;



// WEBPACK FOOTER //
// ./src/components/Results/Drivers/info.js